import useArtifactInfoService from '../artifactInfoService';
import type { ArtifactsInfoResponse } from '../types';
import useCreateArtifactsInfoReceiver, { filterValidArtifactIds } from './createArtifactsInfoReceiver';

type RiskArtifactsInfoReceiver = {
  hookLoading: boolean;
  collectRiskArtifactsData: (initialAttachmentsIds: string[]) => Promise<ArtifactsInfoResponse['artifacts']>;
};

const useRiskArtifactsInfoReceiver = (riskId?: string): RiskArtifactsInfoReceiver => {
  const { getRiskArtifactsInfo } = useArtifactInfoService();

  const collectRiskArtifactsData = useCreateArtifactsInfoReceiver({
    getArtifactsInfo: ids => (riskId ? getRiskArtifactsInfo(riskId, ids) : Promise.resolve({ artifacts: {} })),
    getBatchIds: filterValidArtifactIds,
  });

  return {
    hookLoading: false,
    collectRiskArtifactsData,
  };
};

export default useRiskArtifactsInfoReceiver;
